import { AxiosConfigExplore } from "Explore/Config/AxiosConfig";

export const getAllKeywords = async () => {
  const axios = AxiosConfigExplore();
  const res = await axios.get("/benchmarking/all_keywords");
  return res.data?.data || [];
};

const sanitizeKeywords = (keywords) =>
  (keywords || []).map((k) => k.trim()).filter(Boolean);

// Benchmarking endpoints can return large payloads; give them a generous
// per-request timeout that overrides the default 30s Explore client timeout.
const BENCHMARK_REQUEST_TIMEOUT = 180000;

// Allowed `time_filter` query values for the benchmarking endpoints.
export const BENCHMARK_TIME_FILTERS = ["all", "last_5_years", "last_10_years"];

const timeFilterParams = (time_filter) =>
  BENCHMARK_TIME_FILTERS.includes(time_filter) ? { time_filter } : {};

export const getKeywordStatistics = async ({
  keywords,
  institution_ids,
  time_filter = "all",
}) => {
  const axios = AxiosConfigExplore();
  const res = await axios.post(
    "/benchmarking/institution/statistics/keywords",
    {
      keywords: sanitizeKeywords(keywords),
      institution_ids,
    },
    {
      params: timeFilterParams(time_filter),
      timeout: BENCHMARK_REQUEST_TIMEOUT,
    }
  );
  return res.data;
};

export const getResearcherBenchmarkStatistics = async ({
  keywords,
  researcher_ids,
  time_filter = "all",
}) => {
  const axios = AxiosConfigExplore();
  const res = await axios.post(
    "/benchmarking/researcher/statistics/keywords",
    {
      keywords: sanitizeKeywords(keywords),
      researcher_ids,
    },
    {
      params: timeFilterParams(time_filter),
      timeout: BENCHMARK_REQUEST_TIMEOUT,
    }
  );
  return res.data;
};

export const getUnitBenchmarkStatistics = async ({
  keywords,
  unit_ids,
  time_filter = "all",
}) => {
  const axios = AxiosConfigExplore();
  const res = await axios.post(
    "/benchmarking/unit/statistics/keywords",
    {
      keywords: sanitizeKeywords(keywords),
      unit_ids,
    },
    {
      params: timeFilterParams(time_filter),
      timeout: BENCHMARK_REQUEST_TIMEOUT,
    }
  );
  return res.data;
};

export const getVenueBenchmarkStatistics = async ({
  keywords,
  venue_ids,
  time_filter = "all",
}) => {
  const axios = AxiosConfigExplore();
  const res = await axios.post(
    "/benchmarking/venue/statistics/keywords",
    {
      keywords: sanitizeKeywords(keywords),
      venue_ids,
    },
    {
      params: timeFilterParams(time_filter),
      timeout: BENCHMARK_REQUEST_TIMEOUT,
    }
  );
  return res.data;
};

export const getKeywordDashboardContext = async ({ keywords }) => {
  const axios = AxiosConfigExplore();
  const res = await axios.post(
    "/benchmarking/institution/dashboard/keywords",
    {
      keywords: (keywords || []).map((k) => k.trim()).filter(Boolean),
    },
    { timeout: BENCHMARK_REQUEST_TIMEOUT }
  );
  return res.data?.data || null;
};

export const getBenchmarkKeywordCloud = async ({
  keywords,
  objectIds,
  objectType,
  verify = true,
  granularityLevel = 2,
}) => {
  const axios = AxiosConfigExplore();
  const res = await axios.post(
    "/benchmarking/keyword_cloud",
    {
      keywords: sanitizeKeywords(keywords),
      objectIds: objectIds || [],
      objectType,
      verify,
      granularityLevel,
    },
    { timeout: BENCHMARK_REQUEST_TIMEOUT }
  );
  return res.data ?? {};
};

export const getTopKeywordsAndInstitutions = async (limit = 15) => {
  const axios = AxiosConfigExplore();
  const res = await axios.get(
    `/benchmarking/top_keywords_and_institutions?limit=${limit}`
  );
  return res.data?.data || { keywords: [], institutions: [] };
};
